/**
 * Drop-in replacement for react-router-dom's Link.
 * Vike's client-side router intercepts <a> clicks automatically.
 */
export function Link({
  to,
  children,
  className,
  ...props
}: {
  to: string;
  children: React.ReactNode;
  className?: string;
} & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href">) {
  return (
    <a href={to} className={className} {...props}>
      {children}
    </a>
  );
}

export default Link;
